import Joi from '@hapi/joi'

export const GrossQuantitySchema = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Group cannot have invalid characters`,
        "any.required": `Group required`
    }),
    factoryID: Joi.number().invalid(0).required().label("Factory").messages({
        "any.invalid": `Factory cannot have invalid characters`,
        "any.required": `Factory required`
    }),
    fromDate: Joi.string().invalid("").label("From Date"),
    toDate: Joi.string().invalid("").label("To Date"),
    collectionPointID: Joi.number().allow("").label("Route").messages(),
    minimumGrossQuantityID: Joi.number().allow("").label("Minimum Gross Quantity").messages({
        
    }),
}